(ns teamoesterreich.admin-mode.lebensretter.detail.document-training-part

  (:require [clojure.string]
            [reagent-material-ui.components :as mui]
            [reagent-material-ui.icons.edit :refer [edit]]
            [reagent-material-ui.icons.perm-identity :refer [perm-identity]]
            [reagent.core :as r]
            [teamoesterreich.admin-mode.data.backend :as backend]
            [teamoesterreich.admin-mode.data.lr-clearance :as d-lrClearance]
            [teamoesterreich.admin-mode.data.user :as d-user]

            [teamoesterreich.admin-mode.lebensretter.lr-user.modal.document-assign-modal :as document-assign-modal]
            [teamoesterreich.admin-mode.lebensretter.lr-user.modal.document-select-modal :as select-modal]
            [teamoesterreich.admin-mode.lebensretter.lr-user.modal.document-training-modal :as document-training-modal]
            [teamoesterreich.admin-mode.ui-helper.are-you-sure-modal :as ays-modal]
            [teamoesterreich.admin-mode.ui-helper.preview-modal :as preview-modal]


            [teamoesterreich.element.backend-file :as backend-file]
            [teamoesterreich.util.helper :as h]
            [teamoesterreich.util.log :as log]
            ))




(defn file-upload [!actual-user files userDokument-type]
  (when-let [file (.item files 0)]
    (log/out "got file" files)
    (let [fr (js/FileReader.)]
      (set! (.-onload fr)
            (fn [event]
              (log/out "read file" event (.. event -target -result))
              (d-user/>userDocument-upload (:user-uuid @!actual-user)
                                           userDokument-type
                                           {:buffer       (.. event -target -result)
                                            :file-name    (.-name file)
                                            :content-type (.-type file)
                                            :on-finished  (fn [url] (log/out "got back URL" url))})
              ))
      (.readAsArrayBuffer fr file))))



(defn training-block [!actual-user {:keys [userDocument-uuid userDocument-fileName userDocument-path userDocument-isTraining userDocument-validTo userDocument-since] :as document} wop-clearance]

  (js/console.log "document-block instance" @!actual-user)
  (let [!state (r/atom {:show-delete-modal false :show-select-modal false :enlarge false})
        !enlarge (r/cursor !state [:enlarge])
        !show-delete-modal (r/cursor !state [:show-delete-modal])
        !show-select-modal (r/cursor !state [:show-select-modal])
        !show-training-modal (r/cursor !state [:show-training-modal])
        !show-training-drop-modal (r/cursor !state [:show-training-drop-modal])
        is-cleared? (d-lrClearance/is-cleared (d-user/get-active-clearance @!actual-user))
        ]
    (fn []
      (when true
        (fn []
          [mui/grid
           {:container false :item true
            :key       (str "document-block-" userDocument-uuid)
            :xs        12 :lg 4
            :style     {:padding "15px 15px 0 15px"}
            }
           ;[:pre (pr-str (:lrClearance-trainingDocument wop-clearance))]
           [preview-modal/modal userDocument-path !enlarge]
           [(document-assign-modal/modal-by-tomId !state)]
           [ays-modal/are-you-sure-modal !show-delete-modal "Willst du wirklich dieses Dokument löschen?" "Löschen"
            (fn [] (d-user/>user-edit-document-field (:userDocument-uuid document)
                                                     {:userDocument-active false}
                                                     (fn [] (d-user/actual-user-invalidate !actual-user))))]
           [ays-modal/are-you-sure-modal !show-training-drop-modal [:p "Willst du wirklich dieses Dokument nicht mehr als Qualifikationsnachweis verwenden?"
                                                                    [:br] (when is-cleared? "Die aktive Freigabe wird dadurch beendet!")] "Ja"
            (fn []
              (d-user/>user-edit-document-field (:userDocument-uuid document)
                                                {:userDocument-readonly   false
                                                 :userDocument-isTraining false
                                                 }
                                                (fn []
                                                  (if is-cleared?
                                                    (d-lrClearance/>end-clearance (:lrClearance-uuid wop-clearance)
                                                                                  (fn [] (d-user/actual-user-invalidate !actual-user)))

                                                    (d-user/>user-edit-field (:user-uuid @!actual-user) {:user-identityValid false}
                                                                             (fn [] (d-user/actual-user-invalidate !actual-user)))

                                                    ))))]
           [(document-training-modal/modal !actual-user document !show-training-modal nil)]
           [select-modal/modal !actual-user !show-select-modal "Bitte wähle einen Qualifikationsnachweis"
            (fn [d]
              (when (not= userDocument-uuid (:userDocument-uuid d))
                (log/debug "training document changed  " userDocument-uuid "->" (:userDocument-uuid d))
                (if (nil? (:userDocument-uuid d))
                  (d-lrClearance/>clearance-remove-document (:lrClearance-uuid wop-clearance) "training" #(d-user/actual-user-invalidate !actual-user))
                  (d-lrClearance/>user-add-edit-clearance (:user-uuid @!actual-user)
                                                          {:_trainingDocument-uuid (:userDocument-uuid d)}
                                                          (fn [] (d-user/actual-user-invalidate !actual-user))))
                ))]
           [mui/grid
            {:container  true
             :direction  "row"
             :justify    "space-between"
             :alignItems "flex-start"
             :spacing    3
             :style      {:background-color (if (or userDocument-isTraining (not= "" (str (:lrClearance-qualification-message wop-clearance)))) "#e4f7e4" "#f2cdcd")}
             :onDrop     (fn [editor event]
                           (log/out "dropped!!! " editor event)
                           (.preventDefault event)
                           (.stopPropagation event)
                           (file-upload !actual-user event.files "lebensretter-qualification"))
             }


            [mui/grid
             {:container false :item true :xs 6
              :style     {:fontSize "smaller" :overflow "hidden"}}
             [:h3 "Qualifikation"]
             [:p {}
              (or userDocument-fileName userDocument-path)
              [:br]
              (if userDocument-since (h/date-ger userDocument-since) "")
              [:br]
              "Gültig bis: "
              (if userDocument-validTo (h/date-ger userDocument-validTo) "")

              (when (not= "" (:lrClearance-qualification-message wop-clearance))
                [:div "Begründung: "
                 [:br]
                 [:span {:style {:color "darkblue"}}
                 (:lrClearance-qualification-message wop-clearance)
                 ]])
              ]
             ]
            [mui/grid
             {:container false :item true :xs 6}
             (if (and userDocument-path (not= userDocument-path ""))
               [backend-file/img {:hash     userDocument-path
                                  :preview? true
                                  :onClick  #(swap! !state assoc :enlarge (not (:enlarge @!state)))
                                  :style    {:position "relative" :float "right" :height "120px" :maxWidth "180px" :object-fit "contain"} :alt (str userDocument-fileName)}]
               [:div {:style {:text-align "center" :verticalAlign "middle" :height "120px"}} [:span "Kein Dokument"]])

             ]


            [mui/grid
             {:container false :item true
              :xs        12
              :style     {}}


             [mui/button {:size    "small" :color "secondary" :variant "contained" :style {:margin "0 10px 0 10px"}
                          :endIcon (r/as-element [edit])
                          :onClick #(reset! !show-select-modal true)
                          } "Dokument wählen"]

             [mui/button {:size    "small" :color "primary" :variant "contained" :style {:margin "0 10px 0 10px"}
                          :endIcon (r/as-element [perm-identity])
                          :onClick #(reset! !show-training-modal (:user-tomId @!actual-user))
                          } "bearbeiten"]
             ]

            ]]
          )))))